import ModelData from "../pacakge/public/model_data"
import GameUtil from "../utility/game_util"
import ModuleManager from "../framework/core/module_manager"
import AppData from "../pacakge/public/const/app_data"
import Utility from "../utility/utility"
import LoaclStorage from "./local_storage"
import Share from "../pacakge/public/module/share/share"
import TextureManager from "./texture_manager"
import NetPrompt from "../pacakge/public/module/netprompt/netprompt"
//分享数据
export interface IShareData {
    shareCode?: string,
    shareImg?: string,
    popupType?: number,
    shareText?:string,
    shareTitle?:string
}
export enum ShareCode {
    Hall = "hall"
}
export default class ShareManager {
    static getShareModuleList(callback?) {
        let self = ModelData.instance
        if (self.shareModuleData != null && new Date().getTime() - self.lastGetChannelPlatformRefTime < 600000) {
            callback && callback()
            return
        }
        let requestData: IHttpRequestData = {
            baseUrl: "share/getShareCodeList?",
            useCache: self.shareModuleData != null,
            cacheKey: "share/getShareCodeList",
        }
        if (CC_PREVIEW) {
            requestData.useCacheCallbackBreakRequest = false
        }
        GameUtil.apiHttpGet(requestData, function (retData) {
            let data = retData.data
            self.shareModuleData = []
            for (let i = 0; i < data.length; i++) {
                let shareData: IShareData = {
                    shareCode: data[i].shareCode,
                    shareImg: data[i].shareIcon,
                    popupType: data[i].popupType,
                    shareText:data[i].shareContent,
                    shareTitle:data[i].shareName
                }
                self.shareModuleData.push(shareData)
            }
            callback && callback()
            callback = null
            if (!retData.isResponseCache) {
                self.lastGetChannelPlatformRefTime = new Date().getTime();
            }
        }, function (err) {
            cc.log(err)
            ModuleManager.instance.hideModule("NetPrompt")
            !AppData.showHall && Utility.reportConversionEvent("login_requiredata_request_error")
        })
    }
    static getCurrentDate(){
        let year = new Date().getFullYear()
        let month = new Date().getMonth()
        let day = new Date().getDate()
        return `${year}-${month}-${day}`
    }
    static addShareHistory(shareCode) {
        let str = `shareHistory_${shareCode}_id_${ModelData.instance.roleData.id}_time_${this.getCurrentDate()}`
        cc.log("=======分享编码=======", str)
        let times = parseInt(LoaclStorage.getString(str, "0"))
        times += 1
        LoaclStorage.setString(str, times + "")
    }
    static getShareHistory(shareCode) {
        let str = `shareHistory_${shareCode}_id_${ModelData.instance.roleData.id}_time_${this.getCurrentDate()}`
        cc.log("=======分享编码=======", str)
        let times = parseInt(LoaclStorage.getString(str, "0"))
        return times
    }
    static showShareButton(btn: cc.Node, module: string) {
        let self = ModelData.instance
        if (btn == null)
            return
        if (self.shareModuleData == null) {
            btn.active = false
            return
        }
        if(!CC_JSB){
            btn.active = false
            return
        }
        for (let i = 0; i < self.shareModuleData.length; i++) {
            if (self.shareModuleData[i].shareCode == module) {
                if (self.shareModuleData[i].popupType == 1) {
                    btn.active = true
                } else {
                    if (this.getShareHistory(module) == 0) {
                        btn.active = true
                    }
                }
                return
            }
        }
        btn.active = false
    }
    static getShareData(module){
        let self = ModelData.instance
        let imgUrl:IShareData
        for (let i = 0; i < self.shareModuleData.length; i++) {
            if (self.shareModuleData[i].shareCode == module) {
                imgUrl = self.shareModuleData[i]
            }
        }
        return imgUrl
    }
    static getShareImg(module, callback?) {
        let imgUrl = this.getShareData(module).shareImg
        if (imgUrl != null) {
            TextureManager.instance.downloadImageFromUrlToLocalPath(imgUrl, callback)
        } else {
            ModuleManager.instance.hideModule("NetPrompt")
            ModuleManager.instance.toastKey("share_image_fail");
        }
    }
    static shareSuccess(shareCode,shareChannel,shareType) {
        this.addShareHistory(shareCode)
        ModuleManager.instance.hideModule("NetPrompt")
        let requestData = {
            baseUrl: 'share/addShareHistory?',
            params: {
                appName: shareChannel,
                shareType: shareType,
                shareCode: shareCode,
            }
        }
        GameUtil.apiHttpGet(requestData, function (retData) {
            ModuleManager.instance.toastKey("share_success");
        }, function (err) {
        })
    }

    //shareImg : 本地图片路径
    static prepareShare(shareCode, shareImg?,shareText?) {
        if(!shareImg && ModelData.instance.shareModuleData == null){
            this.getShareModuleList()
            ModuleManager.instance.toastKey("share_image_fail");
            return
        }
        let self = this
        ModuleManager.instance.showModule(NetPrompt)
        let showShare = function (img?,text?) {
            ModuleManager.instance.hideModule("NetPrompt")
            if ((img && img != "") || (text && text != "")) {
                let content
                if (cc.sys.isNative) {
                    if(img && img != ""){
                        content = { "image": img };
                    }else{
                        content = { "text": text };
                    }
                } else if (cc.sys.isBrowser) {
                    content = { "link": text };
                }
                ModuleManager.instance.showModule(Share, {
                    "module": shareCode,
                    "shareContent": content,
                    "shareSuccessCallback": function (shareChannel,shareType) {
                        cc.log("=====分享成功=====",shareCode)
                        self.shareSuccess(shareCode,shareChannel,shareType)
                    }
                })
            } else {
                ModuleManager.instance.hideModule("NetPrompt")
                ModuleManager.instance.toastKey("share_image_fail");
            }
        }
        if (shareImg || shareText) {
            showShare(shareImg,shareText)
        } else {
            let data = this.getShareData(shareCode)
            if(CC_JSB){
                this.getShareImg(shareCode, function (img) {
                    // showShare(img)
                    showShare(null,data.shareText)
                })
            }else{
                showShare(null,data.shareText)
            }
        }
    }

}